import { render, staticRenderFns } from "./ProductOptions.vue?vue&type=template&id=f1fa40c0&scoped=true"
import script from "./ProductOptions.vue?vue&type=script&lang=ts"
export * from "./ProductOptions.vue?vue&type=script&lang=ts"
import style0 from "./ProductOptions.vue?vue&type=style&index=0&id=f1fa40c0&prod&lang=scss&scoped=true"
import style1 from "./ProductOptions.vue?vue&type=style&index=1&id=f1fa40c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1fa40c0",
  null
  
)

export default component.exports